// extracted by mini-css-extract-plugin
module.exports = {"icon":"zj-8p9VdWXjAt4FFEIxSC"};